import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'timeToDate'
})
export class TimeToDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    const now = new Date();
    if (args === 'date') {
      return moment(value).format('DD MMMM YYYY, k:mm');
    }
    if (args === 'month') {
      return moment(value).format('MMMM YYYY');
    }
    return moment(now).to(value);
  }

}
